import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem("lanex-cookies")) setShow(true);
    }, 1400);
    return () => clearTimeout(t);
  }, []);
  const accept = () => { localStorage.setItem("lanex-cookies", "accepted"); setShow(false); };
  const decline = () => { localStorage.setItem("lanex-cookies", "declined"); setShow(false); };
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 60, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-6 left-6 right-6 md:right-auto md:max-w-md z-40 rounded-2xl border border-[color:var(--border-strong)] bg-[color:var(--surface)] p-5 shadow-2xl"
          data-testid="cookie-banner"
        >
          <div className="overline mb-2">Cookies</div>
          <p className="text-[13.5px] text-[color:var(--text-muted)] leading-relaxed">
            We use essential cookies to make our site work, and optional analytics cookies to improve it.
          </p>
          <div className="mt-4 flex gap-2">
            <button onClick={accept} className="h-9 px-4 rounded-full bg-[color:var(--text)] text-[color:var(--bg)] font-semibold text-[12.5px]" data-testid="cookie-accept">
              Accept
            </button>
            <button onClick={decline} className="h-9 px-4 rounded-full border border-[color:var(--border-strong)] font-semibold text-[12.5px]" data-testid="cookie-decline">
              Essential only
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
